<template>
  <a-social-sharing
    hashtags="investingLive"
    twitter-user="investinglive"
    network="linkedin"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
    class="social-icon-border"
  >
    <a-icon
      v-bind="$attrs"
      is-button
      tabindex="-1"
      :width="16"
      :height="16"
      :icon="$attrs.icon || ICON.LINKEDIN"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'LinkedIn',
  mixins: [socialSharing]
}
</script>
